module.exports = __webpack_public_path__ + "static/media/ogrodzenie_panelowe_proste.bc21659a.pdf";